export default __webpack_public_path__ + "static/media/V375MANE2.1e821f6a.pdf";